module.exports = __webpack_public_path__ + "static/media/logo-urps-il-bfc.1364aa7d.png";